import { TopBanner } from './TopBanner';
import FacebookChat from '../facebook/Chat';
import useTranslation from '../i18n/useTranslation';
import { IMessageGroup, MessageGroups } from './MessageGroups';

import LayoutV2 from '@layouts/v2/main.layout';
import FooterExtended from '@ui-kit/footer/FooterExtended';
import Head from 'next/head';

export function FaqPage({ token }) {
  const { t } = useTranslation();
  const messageGroups: IMessageGroup['messageGroups'] = [
    {
      title: t('help_center.faq.topicMyAccount.title'),
      subGroups: [
        {
          questionAnswerList: [
            {
              id: '1',
              firstSentence: t('help_center.faq.topicMyAccount.qLogin'),
              secondSentence: t('help_center.faq.topicMyAccount.aLogin'),
            },
            {
              id: '2',
              firstSentence: t('help_center.faq.topicMyAccount.qLanguage'),
              secondSentence: t('help_center.faq.topicMyAccount.aLanguage'),
            },
            {
              id: '3',
              firstSentence: t('help_center.faq.topicMyAccount.qPassword'),
              secondSentence: t('help_center.faq.topicMyAccount.aPassword'),
            },
            {
              id: '4',
              firstSentence: t('help_center.faq.topicMyAccount.qSubscription'),
              secondSentence: t('help_center.faq.topicMyAccount.aSubscription'),
            },
            {
              id: '5',
              firstSentence: t(
                'help_center.faq.topicMyAccount.qPurchaseHistory',
              ),
              secondSentence: t(
                'help_center.faq.topicMyAccount.aPurchaseHistory',
              ),
            },
          ],
        },
      ],
    },
    {
      title: t('help_center.faq.topicMyLearning.title'),
      subGroups: [
        {
          questionAnswerList: [
            {
              id: '1',
              firstSentence: t('help_center.faq.topicMyLearning.qWhatArchive'),
              secondSentence: t('help_center.faq.topicMyLearning.aWhatArchive'),
            },
            {
              id: '2',
              firstSentence: t('help_center.faq.topicMyLearning.qHowArchive'),
              secondSentence: t('help_center.faq.topicMyLearning.aHowArchive'),
            },
            {
              id: '3',
              firstSentence: t(
                'help_center.faq.topicMyLearning.qOrgLearningTrack',
              ),
              secondSentence: t(
                'help_center.faq.topicMyLearning.aOrgLearningTrack',
              ),
            },
          ],
        },
      ],
    },
    {
      title: t('help_center.faq.topicCourse.title'),
      subGroups: [
        {
          questionAnswerList: [
            {
              id: '1',
              firstSentence: t('help_center.faq.topicCourse.qSearchCourse'),
              secondSentence: t('help_center.faq.topicCourse.aSearchCourse'),
            },
            {
              id: '2',
              firstSentence: t('help_center.faq.topicCourse.qDownloadMaterial'),
              secondSentence: t(
                'help_center.faq.topicCourse.aDownloadMaterial',
              ),
            },
          ],
        },
      ],
    },
    {
      title: t('help_center.faq.topicRegisterCourse.title'),
      subGroups: [
        {
          questionAnswerList: [
            {
              id: '1',
              firstSentence: t('help_center.faq.topicRegisterCourse.qHow'),
              secondSentence: t('help_center.faq.topicRegisterCourse.aHow'),
            },
            {
              id: '2',
              firstSentence: t(
                'help_center.faq.topicRegisterCourse.qHowContinuous',
              ),
              secondSentence: t(
                'help_center.faq.topicRegisterCourse.aHowContinuous',
              ),
            },
            {
              id: '3',
              firstSentence: t(
                'help_center.faq.topicRegisterCourse.qHowCancel',
              ),
              secondSentence: t(
                'help_center.faq.topicRegisterCourse.aHowCancel',
              ),
            },
            {
              id: '4',
              firstSentence: t(
                'help_center.faq.topicRegisterCourse.qRequestChange',
              ),
              secondSentence: t(
                'help_center.faq.topicRegisterCourse.aRequestChange',
              ),
            },
            {
              id: '5',
              firstSentence: t(
                'help_center.faq.topicRegisterCourse.qCannotBook',
              ),
              secondSentence: t(
                'help_center.faq.topicRegisterCourse.aCannotBook',
              ),
            },
            {
              id: '6',
              firstSentence: t('help_center.faq.topicRegisterCourse.qNoBook'),
              secondSentence: t('help_center.faq.topicRegisterCourse.aNoBook'),
            },
            {
              id: '7',
              firstSentence: t(
                'help_center.faq.topicRegisterCourse.qAddToCalendar',
              ),
              secondSentence: t(
                'help_center.faq.topicRegisterCourse.aAddToCalendar',
              ),
            },
          ],
        },
      ],
    },
    {
      title: t('help_center.faq.topicCertificate.title'),
      subGroups: [
        {
          questionAnswerList: [
            {
              id: '1',
              firstSentence: t('help_center.faq.topicCertificate.qCourse'),
              secondSentence: t('help_center.faq.topicCertificate.aCourse'),
            },
            {
              id: '2',
              firstSentence: t('help_center.faq.topicCertificate.qHow'),
              secondSentence: t('help_center.faq.topicCertificate.aHow'),
            },
            {
              id: '3',
              firstSentence: t('help_center.faq.topicCertificate.qChannel'),
              secondSentence: t('help_center.faq.topicCertificate.aChannel'),
            },
          ],
        },
      ],
    },
    {
      title: t('help_center.faq.topicCommuting.title'),
      subGroups: [
        {
          questionAnswerList: [
            {
              id: '1',
              firstSentence: t('help_center.faq.topicCommuting.qHowSeac'),
              secondSentence: t('help_center.faq.topicCommuting.aHowSeac'),
            },
            {
              id: '2',
              firstSentence: t('help_center.faq.topicCommuting.qParking'),
              secondSentence: t('help_center.faq.topicCommuting.aParking'),
            },
          ],
        },
      ],
    },
    {
      title: t('help_center.faq.topicOnlineCourse.title'),
      subGroups: [
        {
          questionAnswerList: [
            {
              id: '1',
              firstSentence: t('help_center.faq.topicOnlineCourse.qHow'),
              secondSentence: t('help_center.faq.topicOnlineCourse.aHow'),
            },
            {
              id: '2',
              firstSentence: t(
                'help_center.faq.topicOnlineCourse.qCannotLearn',
              ),
              secondSentence: t(
                'help_center.faq.topicOnlineCourse.aCannotLearn',
              ),
            },
            {
              id: '3',
              firstSentence: t(
                'help_center.faq.topicOnlineCourse.qCorpacademyLang',
              ),
              secondSentence: t(
                'help_center.faq.topicOnlineCourse.aCorpacademyLang',
              ),
            },
            {
              id: '4',
              firstSentence: t('help_center.faq.topicOnlineCourse.qHowQnA'),
              secondSentence: t('help_center.faq.topicOnlineCourse.aHowQnA'),
            },
          ],
        },
      ],
    },
    {
      title: t('help_center.faq.topicContactChannel.title'),
      subGroups: [
        {
          questionAnswerList: [
            {
              id: '1',
              firstSentence: t(
                'help_center.faq.topicContactChannel.qMemberService',
              ),
              secondSentence: t(
                'help_center.faq.topicContactChannel.aMemberService',
              ),
            },
          ],
        },
      ],
    },
    {
      title: t('help_center.faq.topicLearningPattern.title'),
      subGroups: [
        {
          questionAnswerList: [
            {
              id: '1',
              firstSentence: t(
                'help_center.faq.topicLearningPattern.qDifference',
              ),
              secondSentence: t(
                'help_center.faq.topicLearningPattern.aDifference',
              ),
            },
          ],
        },
      ],
    },
  ];

  return (
    <div>
      <Head>
        <title>{`${t('headerText')} | ${t('help_center.faq.title')}`}</title>
      </Head>
      <TopBanner
        title={t('help_center.title')}
        description={t('help_center.description')}
      />
      <MessageGroups messageGroups={messageGroups} />
      {process.env.NEXT_PUBLIC_HIDE_V3_FEATURE === 'false' && <FacebookChat />}
      <FooterExtended />
    </div>
  );
}
